/**
 * vue-router
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// import { GetCourse, SetActive } from '@/libs/util'
// import * as actions from './store/actions'
// import {getCourseActive}  from './store/getters'
/*function getCourseViewList(tab) {
  const getDateCourseRoutes = tab => [
    {
      path: '/',
      meta: { page: 'course-list', tab },
      component: resolve => require(['./views/course-list/index.vue'], resolve)
    },
    {
      name: 'group',
      path: `/${tab}/group/:courseId`,
      meta: { page: 'group', tab },
      component: resolve => require(['./components/group/index.vue'], resolve)
    }
  ]
  return [
    ...(['my-course', 'my-prepare'].includes(tab) ? getDateCourseRoutes(tab) : []),
    {
      name: 'info',
      path: `/${tab}/info/:courseId/:groupId/:index`,
      meta: { page: 'info', tab },
      component: resolve => require(['./components/info.vue'], resolve)
    }
  ]
}*/
function getCourseViewList(tab) {
  // 根据tab设置对应的type值：my-course对应1，my-prepare对应2
  const getTypeByTab = (tab) => {
    const typeMap = {
      'my-course': 1,
      'my-prepare': 2
    }
    return typeMap[tab] || null // 其他tab返回null
  }

  const getDateCourseRoutes = tab => [
    {
      path: '/',
      meta: {
        page: 'course-list',
        tab,
        type: getTypeByTab(tab) // 存储type参数到meta
      },
      component: resolve => require(['./views/course-list/index.vue'], resolve)
    },
    {
      name: 'group',
      path: `/${tab}/group/:courseId`,
      meta: {
        page: 'group',
        tab,
        type: getTypeByTab(tab) // 存储type参数到meta
      },
      component: resolve => require(['./components/group/index.vue'], resolve)
    }
  ]

  return [
    ...(['my-course', 'my-prepare'].includes(tab) ? getDateCourseRoutes(tab) : []),
    {
      name: 'info',
      path: `/${tab}/info/:courseId/:groupId/:index`,
      meta: {
        page: 'info',
        tab,
        type: getTypeByTab(tab) // 存储type参数到meta
      },
      component: resolve => require(['./components/info.vue'], resolve)
    }
  ]
}

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/my-course'
    },
    {
      path: '/login',
      meta: {
        page: 'login',
        from: 'user'
      },
      component: resolve => require(['./components/user/login.vue'], resolve)
    },
    {
      path: '/my-course',
      name: 'my-course',
      meta: { page: 'my-course', tab: 'my-course' },
      component: resolve => require(['./views/my-course/index.vue'], resolve),
      children: getCourseViewList('my-course')
    },
    {
      path: '/my-prepare',
      name: 'my-prepare',
      meta: { page: 'my-prepare', tab: 'my-prepare' },
      component: resolve => require(['./views/my-prepare/index.vue'], resolve),
      children: getCourseViewList('my-prepare')
    },
    {
      path: '/my-resource',
      meta: { page: 'my-resource', tab: 'my-resource' },
      component: resolve => require(['./views/my-resource/index.vue'], resolve)
    },
    {
      path: '/demo-class',
      meta: { page: 'demo-class', tab: 'demo-class' },
      component: resolve => require(['./views/demo-class/index.vue'], resolve),
      children: [
        {
          path: '/',
          meta: { page: 'demo-class-list', tab: 'demo-class' },
          component: resolve => require(['./views/demo-class-list/index.vue'], resolve)
        },
        {
          path: 'info/:id',
          meta: { page: 'demo-class-info', tab: 'demo-class' },
          component: resolve => require(['./views/demo-class-info/index.vue'], resolve)
        },
        ...getCourseViewList('demo-class')
      ]
    },
    {
      path: '/trial-class',
      meta: { page: 'trial-class', tab: 'trial-class' },
      component: resolve => require(['./views/trial-class/index.vue'], resolve),
      children: [
        {
          path: '/',
          meta: { page: 'trial-class-list', tab: 'trial-class' },
          component: resolve => require(['./views/trial-class-list/index.vue'], resolve)
        },
        {
          name: 'group',
          path: 'group/:id',
          meta: { page: 'trial-class-group', tab: 'trial-class' },
          component: resolve => require(['./views/trial-class-info/index.vue'], resolve)
        },
        ...getCourseViewList('trial-class')
      ]
    },
    {
      path: '/passwordReset',
      meta: {
        page: 'passwordReset',
        from: 'user'
      },
      component: resolve => require(['./components/user/passwordReset.vue'], resolve)
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 添加路由守卫
  // 判断用户是否刷新进入不是首页的情况
  // if (from.path == '/' && to.path != '/') {
  //   let item = ''
  //   switch (to.meta.page) {
  //     case 'part':
  //       item = 'p-' + to.params.partType
  //       break
  //     case 'group':
  //       item = 'g-' + to.params.groupId
  //       break
  //     case 'info':
  //       item = to.params.id
  //       break
  //   }
  //   if (item) {
  //     let _state = store.state
  //     if (!_state.MenuActive[1] && !_state.CourseActive[1]) {
  //       // GetCourse(function () {
  //       //   SetActive(to.params.themeId, item, function () {})
  //       // })
  //     }
  //   }
  // }
  // if (from.path == '/' && to.path == '/') {
  //   // GetCourse(function () {})
  // }
  next()
})

export default router

// {path: '/',redirect: to => {return '/course'}}, {path: '/course',meta: {},component: resolve => require(['./components/course.vue'], resolve)},{path: '/section',meta: {},component: resolve => require(['./components/section.vue'], resolve)},
